import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import VeterinariansComponent from '../components/veterinarians/VeterinariansComponent';

import { GlobalContext } from '../store/Provider';

const Veterinarians = () => {
  const { veterinariansState } = useContext(GlobalContext);
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('veterinarians.name')}</h1>
      {veterinariansState.veterinarians.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <VeterinariansComponent />
      )}
    </Fragment>
  );
};

export default Veterinarians;
